import { render, staticRenderFns } from "./CarDetail.vue?vue&type=template&id=2fdde004"
import script from "./CarDetail.vue?vue&type=script&lang=js"
export * from "./CarDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports